import React from 'react'
import {
  FormControl,
  InputLabel,
  TextField,
  Switch,
  FormControlLabel,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'

export const DynamicKeysTab = ({ dynamic_keys, styles }) => {
  const { t } = useTranslation(['keys'])
  console.log(dynamic_keys)
  return (
    <>
      <InputLabel>{t('devices:params.dynamic_keys.change_desc')}</InputLabel>
      <FormControl style={{ ...styles.field, marginTop: 10 }}>
        <TextField
          label={t('keys:pro.dynamic.a_key')}
          value={dynamic_keys?.a_key}
          inputProps={{
            type: 'string',
          }}
          disabled
          placeholder="FFFFFFFFFFFF"
          style={styles.field}
        />
        <TextField
          label={t('keys:pro.dynamic.b_key')}
          value={dynamic_keys?.b_key}
          inputProps={{
            type: 'string',
          }}
          disabled
          placeholder="FFFFFFFFFFFF"
          style={styles.field}
        />
      </FormControl>
      <FormControlLabel
        disabled
        style={{ marginTop: 10, display: 'flex' }}
        control={<Switch checked={!!dynamic_keys?.personalize} />}
        label={
          <InputLabel>{t('keys:pro.dynamic.personalize_label')}</InputLabel>
        }
        labelPlacement="left"
      />

      <FormControlLabel
        disabled
        style={{ marginTop: 10, display: 'flex' }}
        control={<Switch checked={!!dynamic_keys?.dynamic_key_on} />}
        label={
          <InputLabel>
            {dynamic_keys?.dynamic_key_on
              ? t('keys:pro.dynamic.on')
              : t('keys:pro.dynamic.off')}
          </InputLabel>
        }
        labelPlacement="left"
      />
    </>
  )
}
